import type { AppIconName } from "@shared/ui/chakra/data-display/icon/icon.tsx";

import { forwardRef } from "react";

import { Link, type LinkProps } from "@chakra-ui/react";

import { Icon } from "@shared/ui/chakra/data-display/icon";

type Props = Omit<LinkProps, "children"> & {
  activeIconName: AppIconName;
  "data-status"?: string;
  iconName: AppIconName;
  label: string;
};

export const NavBarLink = forwardRef<HTMLAnchorElement, Props>(
  ({ activeIconName, iconName, label, ...rest }, ref) => {
    const isActive = rest["data-status"] === "active";
    return (
      <Link
        _currentPage={{
          color: { base: "icon.icon_accent", lg: "text.fg_accent" },
        }}
        flexDirection="column"
        gap="4px"
        justifyContent="center"
        px={{ lg: "12px" }}
        py={{ base: "6px", lg: "8px" }}
        ref={ref}
        textStyle={{ base: "2xs", lg: "md" }}
        variant="empty"
        w="full"
        {...rest}
      >
        <Icon
          hideFrom="desktop"
          name={isActive ? activeIconName : iconName}
          size="lg"
        />
        {label}
      </Link>
    );
  },
);
